import { langugae } from "../../../../config/languageJSON";
import { displayAmount } from "../utils/productWiseSkuPdfUtils";
import {
  fullWidthTable,
  headerCell,
  headerTitle,
} from "../styles/productWiseSkuPdfStyles";

// Shared SKU PDF header. Pass title; set showBeatName for billing load sheet only.
const ProductWiseSkuPdfHeader = ({
  title,
  billList,
  dateLabel,
  showBeatName = false,
}) => {
  return (
    <table style={fullWidthTable}>
      <tr>
        <table style={fullWidthTable}>
          <tr>
            <td style={headerCell}>
              <div style={headerTitle}>{title ? title : ""}</div>
              <div className="headPadding">
                {langugae[2].distName ? langugae[2].distName + " : " : ""}
                {localStorage.getItem("distributorName")}
              </div>
              {showBeatName ? (
                <div className="headPadding">
                  {langugae[2].beatName ? langugae[2].beatName + " : " : ""}
                  {billList.beatName ? billList.beatName : "-"}
                </div>
              ) : null}
              <div className="headPadding">
                {langugae[2].amount ? langugae[2].amount + " : " : ""}
                {displayAmount(billList.amt)}
              </div>
              <div className="headPadding">
                {langugae[2].date ? langugae[2].date + " : " : ""}
                {dateLabel}
              </div>
            </td>
          </tr>
        </table>
      </tr>
    </table>
  );
};

export default ProductWiseSkuPdfHeader;
